"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMeasureWithValue = void 0;
function isMeasureWithValue(item, prop) {
    if (prop != null) {
        if (item == null) {
            return false;
        }
        item = item[prop];
    }
    return (item != null &&
        typeof item === 'object' &&
        item.value != null &&
        (typeof item.value !== 'number' || !isNaN(item.value)) &&
        typeof item.unit === 'string');
}
exports.isMeasureWithValue = isMeasureWithValue;
